import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_AUTH_CLIENT_ID } from "./src/constants/settings";
import { Provider } from "react-redux";
import { store } from "./src/redux/store";
export * from "./gatsby-shared";

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_AUTH_CLIENT_ID}>
      <Provider store={store}>{element}</Provider>
    </GoogleOAuthProvider>
  );
};
